import React from 'react'
import {
  Shield
} from 'lucide-react'

const AdminPrivacyPortal: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
          <div className="flex items-start">
            <Shield className="h-6 w-6 text-blue-600 mt-1 mr-4" />
            <div>
              <h3 className="text-sm font-semibold text-blue-900 mb-2">Privacy Settings Moved</h3>
              <p className="text-sm text-blue-800">
                All privacy-related settings have been moved to Trust Center → Content → Privacy.
                Please navigate there to manage Cookie Settings, Privacy Settings, Data Retention, and Privacy Requests.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminPrivacyPortal
